import type { Agreements } from '../agreement';
import type { SearchParameters } from '../searchParameters';
import type { SearchProfile } from '../searchProfile';
import { isPaViewOnly } from './paAgreementState';
import { isFilteredByAgreement, isGroupedByEvent } from '../searchParameters';

// Batch download is available because the search is agreement-scoped: every
// asset in the result set is already covered by that agreement, so there is no
// separate per-asset eligibility check.
//
// A premium-access preview is the exception. The previewed agreement sits in
// the search like any other, so the search reads as agreement-scoped, but
// nothing in it is downloadable — the overlay hides every asset's download
// button on the same isPaPreview flag. Without this term the page would offer
// a batch affordance whose individual download buttons are all hidden.
//
// A single-seat subscription preview needs no matching term: a previewed
// subscription never appears in searchParameters, so the first condition
// already refuses it. The tests pin that, including the case that would start
// returning true if it ever did appear.
export const canBatchDownload = (
  searchParameters: SearchParameters,
  agreements: Agreements,
  searchProfile: SearchProfile
): boolean =>
  isFilteredByAgreement(searchParameters) &&
  !searchProfile.isPaPreview &&
  !isPaViewOnly(agreements, searchParameters) &&
  !isGroupedByEvent(searchParameters);
